module.exports = __webpack_public_path__ + "fb954eeca6164929f629a1ef43981555.ttf";